export const customEn = {
  StepsTitle: 'Meet Single Truckers Near You Today'
};

export const customEs = {};
export const customDa = {};
export const customDe = {};
export const customFi = {};
export const customSv = {};
export const customFr = {};
export const customHu = {};



// WEBPACK FOOTER //
// ./src/constants/custom.localization.js